import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";

const styles = theme => ({
    root: {
        fontFamily: theme.fonts.bold,
        fontSize: "18px",
        lineHeight: ".89",
        letterSpacing: "2.6px",
        color: theme.palette.colors.darkSlateBlue,
        textTransform: "uppercase",
        position: "relative",
        margin: "0 0 60px 30px",
        "&:after": {
            content: '""',
            position: "absolute",
            bottom: "-22px",
            height: "2px",
            width: "80px",
            backgroundColor: "#5812fe",
            left: "0",
        },
    },
    underlineRight: {
        margin: "0 0 50px 0",
        fontSize: "36px",
        textTransform: "none",
        "&:after": {
            display: "none",
        },
    },
    [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
        root: {
            marginLeft: "20px",
        },
    },
    [`@media (max-width: ${theme.media.sm})`]: {
        root: {
            fontSize: "16px",
            lineHeight: "1",
            letterSpacing: "2px",
            marginLeft: "0",
            marginBottom: "24px",
            "&:after": {
                display: "none",
            },
        },
        underlineRight: {
            margin: "0 auto 24px auto",
            textAlign: "center",
            fontSize: "30px",
        },
    },
    [`@media (max-width: ${theme.media.xs})`]: {
        underlineRight: {
            margin: "0 auto 24px auto",
            textAlign: "left",
        },
    },
    ["@media (max-width: 350px)"]: {
        underlineRight: {
            fontSize: "25px",
        },
    },
});

const Header = ({ classes, children, underlineRight, h2Tag }) => {
    return children && typeof children == "string" ? (
        h2Tag ? (
            <h2
                className={classNames(classes.root, {
                    [classes.underlineRight]: !!underlineRight,
                })}
                dangerouslySetInnerHTML={{ __html: children }}
            />
        ) : (
            <div
                className={classNames(classes.root, {
                    [classes.underlineRight]: !!underlineRight,
                })}
                dangerouslySetInnerHTML={{ __html: children }}
            />
        )
    ) : h2Tag ? (
        <h2
            className={classNames(classes.root, {
                [classes.underlineRight]: !!underlineRight,
            })}
        >
            {children}
        </h2>
    ) : (
        <div
            className={classNames(classes.root, {
                [classes.underlineRight]: !!underlineRight,
            })}
        >
            {children}
        </div>
    );
};

export default withStyles(styles)(Header);
